(ns common.schema.entities.fundraising-opportunity.permissions
  (:require [common.modules :as modules]
            [common.schema.entities.permissions :as entity-permissions]))

(defn read-permissions?
  [{:keys [account-current-permissions entity]}]
  (and (modules/has-module? account-current-permissions :module/fundraising)
       (contains? (:account-access-to-pipelines account-current-permissions)
                  (-> entity
                      :fundraising-opportunity/pipeline
                      :db/id))))

(defn disable-permissions?
  [ctx]
  (entity-permissions/disable-when-no-write-permission ctx))
